import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import _actions from '../../actions';
import YesNoDialog from '../../components/common/YesNoDialog';
import DeleteDialog from '../../components/common/DeleteDialog';
import VersionBox from '../../components/common/VersionBox';
import ErrorList from '../../components/status/ErrorList';
import PreviewAppLinks from '../../components/common/PreviewAppLinks';
import PreviewLogo from '../../components/preview/PreviewLogo';
import i18n from '../../i18n';
import Promote from '../../components/svg/Promote';

class Results extends React.Component {
    constructor(props) {
        super(props);
        this.errors = [];
        this.state = {
            projectScanned: false,
            scanFailed: false,
            publishFailed: false,
            confirmPublish: false,
            showPreview: true,
        };
        this.publishApp = this.publishApp.bind(this);
        this.openConfirmDialog = this.openConfirmDialog.bind(this);
        this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
        this.publishButton = this.publishButton.bind(this);
    }

    componentDidMount() {
        this.props.actions.getProject(this.props.match.params.projectId);
        this.props.actions.checkProjectConfig(this.props.match.params.projectId);
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
    }

    componentDidUpdate(prevProps, prevState) {
        let stateObj = {};
        if (!prevState.loaded && this.props.versions.select.id) {
            stateObj.loaded = true;
            stateObj.changes = this.props.versions.select.changes;
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(stateObj);
        }
        if (this.props.proj_conf.projectScanned && !prevProps.proj_conf.projectScanned) {
            stateObj = {
                ...stateObj,
                projectScanned: true,
                scanFailed: this.props.proj_conf.scanFailed,
            };
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(stateObj);
        } else if (this.props.proj_conf.publishFailed && !prevProps.proj_conf.publishFailed) {
            stateObj = {
                ...stateObj,
                publishFailed: true,
            };
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(stateObj);
        }
    }

    openConfirmDialog() {
        this.setState({ confirmPublish: true });
    }

    closeConfirmDialog() {
        this.setState({ confirmPublish: false });
    }

    publishApp() {
        // eslint-disable-next-line react/destructuring-assignment
        this.props.actions.publishProject(
            this.props.match.params.projectId,
            this.props.profiles.data.givingChurchId,
        );
        this.closeConfirmDialog();
    }

    publishButton() {
        const live = this.props.projects.data.filter((project) => { return project.liveVersion; });
        const liveBool = live.length > 0;
        if (!liveBool || this.props.projects.selected.liveVersion) {
            this.publishApp();
        } else {
            this.openConfirmDialog();
        }
    }

    render() {
        const version = this.props.versions.select;
        this.errors = this.props.proj_conf.data ? this.props.proj_conf.data : [];
        const address = `${this.props.versions.select.churchStreetAddress || ''} ${this.props.versions.select.churchCity || ''}, ${this.props.versions.select.churchState || ''} ${this.props.versions.select.churchZip || ''}`;
        const logoPath = version.logoImage?.imagePath;
        const isTrial = localStorage.getItem('IsTrial');
        let publishConfirmModal = '';
        if (this.state.confirmPublish) {
            publishConfirmModal = (
                <YesNoDialog
                    Message={(
                        <DeleteDialog
                            open={i18n.t('status.results.success.publish1')}
                            name={version.name ? `${version.name}` : i18n.t('projects.null')}
                            warning={i18n.t('status.results.success.publish2')}
                        />
                    )}
                    ExecuteAction={this.publishApp}
                    CloseDialog={this.closeConfirmDialog}
                    Visible={this.state.confirmPublish}
                    title="Are you sure?"
                    YesText={i18n.t('status.results.success.publish-yes')}
                    NoText={i18n.t('status.results.success.publish-no')}
                />
            );
        }
        const previewResults = (
            <PreviewLogo
                description={this.props.versions.select.description}
                logo={logoPath}
                church={typeof this.props.versions.select.churchName !== 'undefined' ? this.props.versions.select.churchName : ''}
                address={address}
            />
        );

        let baseVersionLink = '';
        if (this.props && this.props.match && this.props.match.params) {
            baseVersionLink = `/projects/${this.props.match.params.projectId}`;
        }
        const newStatus = this.props.versions.select.version === 1
            && moment(this.props.versions.select.dateModified)
                .diff(moment(this.props.versions.select.dateCreated)) < 2000;

        return (
            <VersionBox
                name={version.name}
                versionNumber={version.version}
                saving={version.inProgress}
                menuSection="Status"
                previewCssClass="app-settings_general-info"
                previewChild={previewResults}
                configCode={this.props.versions.select.configCode}
                showPreview={this.state.showPreview}
                x
            >
                <div data-qa="results-page-body" id="results-page-body" className="content-inside">
                    {(!this.props.versions.select.sameAsLive && newStatus) && (
                        <div className="form-wrapper">
                            <h1
                                data-qa="results-empty-header"
                                className="status"
                            >
                                {i18n.t('status.results.empty.header')}
                            </h1>

                            <p
                                data-qa="results-empty-subhead1"
                                className="lead has-decoration"
                            >
                                {i18n.t('status.results.empty.subtitle')}
                            </p>

                            <p
                                data-qa="results-empty-subhead2"
                                className="status subtitle text-center"
                            >
                                {i18n.t('status.results.empty.subtitle2')}
                            </p>
                            <div
                                data-qa="results-empty-link"
                                className="btn-wrapper btn-wrapper__status text-center"
                            >
                                <Link to={{
                                    pathname: `${baseVersionLink}/`,
                                }}
                                >
                                    {/* eslint-disable-next-line react/button-has-type */}
                                    <button
                                        data-qa="results-empty-button"
                                        className="btn btn-primary btn-sm"
                                    >
                                        {' '}
                                        {i18n.t('status.results.empty.button')}
                                    </button>
                                </Link>
                            </div>
                            <p
                                data-qa="results-empty-help"
                                className="status helper-text"
                            >
                                {' '}
                                {i18n.t('status.results.empty.help')}
                            </p>
                            {/* <PreviewAppLinks showMessage /> */}

                        </div>
                    )}
                    {(!this.props.versions.select.sameAsLive
                        && this.errors.length > 0)
                    && this.state.projectScanned
                    && !this.state.scanFailed
                    && !newStatus
                    && (
                        <div className="form-wrapper">
                            <h1
                                data-qa="results-problems-header"
                                className="status"
                            >
                                {i18n.t('status.results.problems.header')}
                            </h1>

                            <p
                                data-qa="results-problems-subhead1"
                                className="lead has-decoration"
                            >
                                {i18n.t('status.results.problems.subtitle1a')}
                                <span
                                    className="blue-text"
                                >
                                    {i18n.t('status.results.problems.subtitle1blue')}
                                </span>
                                {' '}
                                {i18n.t('status.results.problems.subtitle1c')}
                            </p>

                            <h2
                                data-qa="results-problems-subhead2"
                                className="subtitle text-center"
                            >
                                {i18n.t('status.results.problems.subtitle2')}
                            </h2>

                            <ErrorList
                                projectId={this.props.match.params.projectId}
                                errors={this.errors}
                                pagesFlag={this.props.flags.results?.customContentPages}
                            />

                            {/* <PreviewAppLinks showMessage /> */}

                        </div>
                    )}
                    {(!this.props.versions.select.sameAsLive
                        && this.errors.length === 0)
                    && this.state.projectScanned
                    && !this.state.scanFailed
                    && !this.state.publishFailed
                    && (

                        <div className="form-wrapper">

                            <h1 data-qa="results-success-header" className="status">Great Job!</h1>

                            <p
                                data-qa="results-success-subhead1"
                                className="lead has-decoration"
                            >
                                {i18n.t('status.results.success.subtitle1a')}
                                <br />
                                {i18n.t('status.results.success.subtitle1b')}
                                <span
                                    className="blue-text"
                                >
                                    {i18n.t('status.results.success.subtitle1blue')}
                                </span>
                            </p>

                            <p
                                data-qa="results-success-subhead2"
                                className="post-lead-text text-center"
                            >
                                {i18n.t('status.results.success.subtitle2')}
                            </p>
                            <div className="btn-wrapper btn-wrapper__status text-center">
                                {/* eslint-disable-next-line react/button-has-type */}
                                <button
                                    data-qa="results-success-publish-button"
                                    onClick={this.publishButton}
                                    className="btn btn-primary btn-sm"
                                    disabled={isTrial? true : false}
                                >
                                    {i18n.t('status.results.success.button')}
                                </button>
                            </div>

                            {/* <PreviewAppLinks showMessage /> */}

                        </div>
                    )}

                    {((!this.props.versions.select.sameAsLive
                        && this.state.projectScanned
                        && this.state.scanFailed)
                        || (this.state.publishFailed))
                    && (
                        <div className="form-wrapper">

                            <h1
                                data-qa="results-error-header"
                                className="status"
                            >
                                {i18n.t('status.results.error.header')}
                            </h1>

                            <p
                                data-qa="results-error-subhead1"
                                className="lead has-decoration"
                            >
                                {i18n.t('status.results.error.subtitle1')}
                            </p>

                            <p
                                data-qa="results-error-subhead2"
                                className="post-lead-text text-center"
                            >
                                {i18n.t('status.results.error.subtitle2')}
                            </p>

                        </div>
                    )}
                    {this.props.versions.select.sameAsLive && (

                        <div className="form-wrapper">

                            <h1
                                data-qa="results-live-header"
                                className="status"
                            >
                                {i18n.t('status.results.live.header')}
                            </h1>

                            <p
                                data-qa="results-live-subhead1"
                                className="lead has-decoration"
                            >
                                {i18n.t('status.results.live.subtitle1')}
                            </p>

                            <p
                                data-qa="results-live-subhead2"
                                className="post-lead-text text-center"
                            >
                                {i18n.t('status.results.live.subtitle2')}
                            </p>

                            <h2
                                data-qa="results-live-subhead3"
                                className="emphasis text-center"
                            >
                                {i18n.t('status.results.live.subtitle3')}
                            </h2>
                            <div
                                data-qa="results-live-checklist-wrap"
                                className="status-checklist-wrap"
                            >

                                <ul data-qa="results-live-checklist" className="status-checklist">
                                    <li data-qa="results-live-checklist1">{i18n.t('status.results.live.list1')}</li>
                                    <li data-qa="results-live-checklist2">{i18n.t('status.results.live.list2')}</li>
                                    <li data-qa="results-live-checklist3">{i18n.t('status.results.live.list3')}</li>
                                    <li data-qa="results-live-checklist4">{i18n.t('status.results.live.list4')}</li>
                                </ul>

                            </div>
                            <div className="btn-wrapper btn-wrapper__status text-center">
                                <Link to="/promote">
                                    {/* eslint-disable-next-line react/button-has-type */}
                                    <button
                                        data-qa="results-live-promote button"
                                        className="btn btn-primary btn-sm"
                                    >
                                        <span
                                            className="icon-promote"
                                        >
                                            <Promote />
                                        </span>
                                        <span
                                            className="button-text"
                                        >
                                            {' '}
                                            {i18n.t('status.results.live.promote-button')}
                                        </span>
                                    </button>
                                </Link>
                            </div>

                        </div>
                    )}

                    <div data-qa="results-publish-confirm-modal" className="publish-modal">
                        {publishConfirmModal}
                    </div>
                </div>
            </VersionBox>

        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Results);
